(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-no-usf"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(function () {
  if (window.__vesperCollection) return;
  window.__vesperCollection = true;

  var root = function () {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var money = function (cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  };
  var sized = function (url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  };
  var norm = function (u) {
    return String(u || '').replace(/^https?:/, '').split('?')[0];
  };

  /* ---------------- Filters ---------------- */
  var timer;

  function disableEmpty(form) {
    form.querySelectorAll('input[type="number"], input[type="text"]').forEach(function (i) {
      if (!i.value) i.disabled = true;
    });
  }
  function submitForm(form) {
    if (form.requestSubmit) {
      form.requestSubmit();
    } else {
      disableEmpty(form);
      form.submit();
    }
  }
  function isManual(vc) {
    return vc.classList.contains('vc--drawer') ||
      vc.classList.contains('vc--manual') ||
      window.matchMedia('(max-width: 989.98px)').matches;
  }
  function closeFilters(vc) {
    if (!vc) return;
    vc.classList.remove('is-filters-open');
    document.documentElement.style.overflow = '';
    var opener = vc.querySelector('[data-vc-open-filters]');
    if (opener) {
      opener.setAttribute('aria-expanded', 'false');
      opener.focus();
    }
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.matches && f.matches('[data-vc-form]')) disableEmpty(f);
  });

  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-vc-form] input:disabled').forEach(function (i) {
      if (i.type === 'number' || i.type === 'text') i.disabled = false;
    });
  });

  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el.closest) return;
    var form = el.closest('[data-vc-form]');
    if (!form) return;
    var vc = form.closest('.vc');
    if (el.matches('[data-vc-sort]')) {
      submitForm(form);
      return;
    }
    if (!el.matches('[data-vc-auto]')) return;
    if (isManual(vc)) return;
    clearTimeout(timer);
    timer = setTimeout(function () { submitForm(form); }, 350);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.vc.is-filters-open').forEach(closeFilters);
    }
  });

  /* ---------------- Card swatches ---------------- */
  function primaryImg(card) { return card.querySelector('.vc-img--primary'); }

  function showImage(card, url) {
    var img = primaryImg(card);
    if (!img || !url) return;
    if (!img.dataset.vcSrc) {
      img.dataset.vcSrc = img.getAttribute('src') || '';
      img.dataset.vcSrcset = img.getAttribute('srcset') || '';
    }
    img.removeAttribute('srcset');
    img.src = url;
    card.classList.add('is-swapped');
  }
  function restoreImage(card) {
    var img = primaryImg(card);
    if (!img || !img.dataset.vcSrc) return;
    if (img.dataset.vcSrcset) img.setAttribute('srcset', img.dataset.vcSrcset);
    img.src = img.dataset.vcSrc;
    card.classList.remove('is-swapped');
  }
  function lockSwatch(sw) {
    var card = sw.closest('.vc-card');
    if (!card || !sw.dataset.image) return;
    card.querySelectorAll('.vc-sw').forEach(function (b) {
      b.classList.remove('is-active');
      b.setAttribute('aria-pressed', 'false');
    });
    sw.classList.add('is-active');
    sw.setAttribute('aria-pressed', 'true');
    card.dataset.vcLocked = sw.dataset.image;
    showImage(card, sw.dataset.image);
    if (sw.dataset.variant) {
      card.querySelectorAll('a.vc-media-link, a.vc-title').forEach(function (a) {
        a.href = a.href.split('?')[0] + '?variant=' + sw.dataset.variant;
      });
    }
  }

  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest && e.target.closest('[data-vc-swatch]');
    if (sw && sw.dataset.image) showImage(sw.closest('.vc-card'), sw.dataset.image);
  });
  document.addEventListener('mouseout', function (e) {
    var sw = e.target.closest && e.target.closest('[data-vc-swatch]');
    if (!sw) return;
    var card = sw.closest('.vc-card');
    if (card.dataset.vcLocked) showImage(card, card.dataset.vcLocked);
    else restoreImage(card);
  });

  /* ---------------- Quick view ---------------- */
  function bubble(count) {
    document.querySelectorAll('.cart-bubble').forEach(function (b) { b.classList.remove('visually-hidden'); });
    document.querySelectorAll('.cart-bubble__text-count').forEach(function (n) {
      n.textContent = count;
      n.classList.remove('hidden');
    });
  }

  function openQuickView(btn) {
    var vc = btn.closest('.vc');
    var dlg = vc.querySelector('.vc-qv');
    var card = btn.closest('.vc-card');
    var titleLink = card.querySelector('a.vc-title');
    if (!dlg || typeof dlg.showModal !== 'function') {
      if (titleLink) window.location.href = titleLink.href;
      return;
    }
    var swatches = {};
    try { swatches = JSON.parse(card.dataset.swatches || '{}'); } catch (err) {}
    var content = dlg.querySelector('.vc-qv-content');
    content.innerHTML = '<p class="vc-qv-loading">&hellip;</p>';
    dlg.__vc = null;
    if (!dlg.open) dlg.showModal();

    fetch(root() + 'products/' + encodeURIComponent(card.dataset.handle) + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('load'); return r.json(); })
      .then(function (p) { renderQV(vc, dlg, p, swatches); })
      .catch(function () {
        content.innerHTML = '<p class="vc-qv-error"><a href="' + esc(titleLink ? titleLink.href : '#') + '">' + esc(vc.dataset.qvDetails) + '</a></p>';
      });
  }

  function renderQV(vc, dlg, p, swatches) {
    var d = vc.dataset;
    var colorNames = (d.colorOptions || '').split('|').filter(Boolean);
    var variants = p.variants || [];
    var options = (p.options || []).map(function (o, i) {
      var name = typeof o === 'string' ? o : o.name;
      var vals = (typeof o === 'object' && o.values && o.values.length) ? o.values.slice() : [];
      if (!vals.length) {
        variants.forEach(function (v) {
          var x = v.options[i];
          if (vals.indexOf(x) < 0) vals.push(x);
        });
      }
      return { name: name, values: vals };
    });
    var single = options.length === 1 && options[0].values.length === 1 && options[0].values[0] === 'Default Title';
    var start = variants.filter(function (v) { return v.available; })[0] || variants[0];
    var imgs = (p.images && p.images.length) ? p.images : (p.featured_image ? [p.featured_image] : []);
    var url = p.url || (root() + 'products/' + p.handle);
    var st = { sel: start.options.slice(), qty: 1, cur: '' };

    var optHtml = '';
    if (!single) {
      options.forEach(function (o, i) {
        var isColor = colorNames.indexOf(String(o.name).toLowerCase()) > -1;
        optHtml += '<div class="vc-qv-opt"><div class="vc-qv-optname">' + esc(o.name) + ': <b data-vc-optlabel="' + i + '"></b></div><div class="vc-qv-vals">';
        o.values.forEach(function (v) {
          var sw = isColor && swatches[v];
          optHtml += '<button type="button" class="vc-qv-val' + (sw ? ' vc-qv-val--sw' : '') + '" data-opt="' + i + '" data-value="' + esc(v) + '"' +
            (sw ? ' style="--vc-sw:' + esc(sw) + '" aria-label="' + esc(v) + '" title="' + esc(v) + '"' : '') + '>' +
            (sw ? '' : esc(v)) + '</button>';
        });
        optHtml += '</div></div>';
      });
    }

    var thumbs = '';
    if (imgs.length > 1) {
      thumbs = '<div class="vc-qv-thumbs">';
      imgs.forEach(function (src, i) {
        thumbs += '<button type="button" class="vc-qv-thumb' + (i === 0 ? ' is-active' : '') + '" data-src="' + esc(src) + '"><img src="' + esc(sized(src, 160)) + '" alt="" loading="lazy"></button>';
      });
      thumbs += '</div>';
    }

    var desc = '';
    if (d.qvDesc === 'true' && p.description) {
      var text = new DOMParser().parseFromString(p.description, 'text/html').body.textContent.replace(/\s+/g, ' ').trim();
      if (text.length > 260) text = text.slice(0, 257).replace(/\s+\S*$/, '') + '\u2026';
      if (text) desc = '<p class="vc-qv-desc">' + esc(text) + '</p>';
    }

    dlg.querySelector('.vc-qv-content').innerHTML =
      '<div class="vc-qv-inner">' +
        '<div class="vc-qv-gallery">' +
          '<div class="vc-qv-main"><img class="vc-qv-img" alt="' + esc(p.title) + '" src="' + esc(sized(imgs[0], 1000)) + '"></div>' +
          thumbs +
        '</div>' +
        '<div class="vc-qv-info">' +
          '<h2 class="vc-qv-title">' + esc(p.title) + '</h2>' +
          '<div class="vc-qv-price"></div>' +
          optHtml +
          '<div class="vc-qv-qty"><button type="button" data-vc-qty="-1" aria-label="-">&minus;</button><span></span><button type="button" data-vc-qty="1" aria-label="+">+</button></div>' +
          '<button type="button" class="vc-qv-atc"></button>' +
          '<p class="vc-qv-msg" role="status" aria-live="polite"></p>' +
          desc +
          '<a class="vc-qv-more" href="' + esc(url) + '">' + esc(d.qvDetails) + '</a>' +
        '</div>' +
      '</div>';

    var el = {
      img: dlg.querySelector('.vc-qv-img'),
      price: dlg.querySelector('.vc-qv-price'),
      atc: dlg.querySelector('.vc-qv-atc'),
      msg: dlg.querySelector('.vc-qv-msg'),
      qty: dlg.querySelector('.vc-qv-qty span')
    };

    st.find = function () {
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === st.sel[i]; });
      })[0];
    };
    st.setImage = function (src) {
      if (norm(src) === st.cur) return;
      st.cur = norm(src);
      el.img.src = sized(src, 1000);
      dlg.querySelectorAll('.vc-qv-thumb').forEach(function (b) {
        b.classList.toggle('is-active', norm(b.dataset.src) === st.cur);
      });
    };
    st.sync = function () {
      var v = st.find();
      dlg.querySelectorAll('.vc-qv-val').forEach(function (b) {
        var i = +b.dataset.opt;
        var on = st.sel[i] === b.dataset.value;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var possible = variants.some(function (x) {
          return x.available && x.options.every(function (o, j) {
            return j === i ? o === b.dataset.value : o === st.sel[j];
          });
        });
        b.classList.toggle('is-unavailable', !possible);
      });
      dlg.querySelectorAll('[data-vc-optlabel]').forEach(function (n) {
        n.textContent = st.sel[+n.dataset.vcOptlabel];
      });
      if (v) {
        el.price.innerHTML = (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '') + '<span>' + money(v.price) + '</span>';
        if (v.featured_image && v.featured_image.src) st.setImage(v.featured_image.src);
        el.atc.disabled = !v.available;
        el.atc.textContent = v.available ? d.qvAtc : d.qvSold;
      } else {
        el.price.innerHTML = '';
        el.atc.disabled = true;
        el.atc.textContent = d.qvSold;
      }
      el.qty.textContent = st.qty;
    };
    st.add = function () {
      var v = st.find();
      if (!v || !v.available) return;
      el.atc.disabled = true;
      el.atc.setAttribute('aria-busy', 'true');
      el.msg.textContent = '';
      fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: st.qty }] })
      })
        .then(function (r) {
          return r.json().then(function (j) {
            if (!r.ok) throw new Error(j.description || j.message || 'error');
            return j;
          });
        })
        .then(function () {
          return fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          bubble(cart.item_count);
          document.dispatchEvent(new CustomEvent('vesper:cart-add', { detail: { cart: cart } }));
          if (d.afterAdd === 'cart_page') {
            window.location.href = root() + 'cart';
            return;
          }
          el.msg.innerHTML = esc(d.qvAdded) + ' <a href="' + root() + 'cart">' + esc(d.qvCart) + '</a>';
        })
        .catch(function (err) {
          el.msg.textContent = (err && err.message && err.message !== 'error') ? err.message : 'Could not add to cart.';
        })
        .then(function () {
          el.atc.removeAttribute('aria-busy');
          st.sync();
        });
    };

    dlg.__vc = st;
    st.sync();
  }

  function handleQV(dlg, t) {
    if (t === dlg || t.closest('[data-vc-qv-close]')) {
      dlg.close();
      return;
    }
    var st = dlg.__vc;
    if (!st) return;
    var val = t.closest('.vc-qv-val');
    if (val) {
      st.sel[+val.dataset.opt] = val.dataset.value;
      st.sync();
      return;
    }
    var th = t.closest('.vc-qv-thumb');
    if (th) {
      st.setImage(th.dataset.src);
      return;
    }
    var q = t.closest('[data-vc-qty]');
    if (q) {
      st.qty = Math.max(1, st.qty + (+q.dataset.vcQty));
      st.sync();
      return;
    }
    if (t.closest('.vc-qv-atc')) st.add();
  }

  /* ---------------- One delegated click handler ---------------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;

    var dlg = t.closest('.vc-qv') || (t.classList && t.classList.contains('vc-qv') ? t : null);
    if (dlg) { handleQV(dlg, t); return; }

    var open = t.closest('[data-vc-open-filters]');
    if (open) {
      var vc = open.closest('.vc');
      vc.classList.add('is-filters-open');
      open.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      setTimeout(function () {
        var c = vc.querySelector('.vc-filters [data-vc-close-filters]');
        if (c) c.focus();
      }, 60);
      return;
    }

    var close = t.closest('[data-vc-close-filters]');
    if (close) { closeFilters(close.closest('.vc')); return; }

    var sw = t.closest('[data-vc-swatch]');
    if (sw) { lockSwatch(sw); return; }

    var qv = t.closest('[data-vc-qv]');
    if (qv) { openQuickView(qv); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vesper-box-builder"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  if (window.__vesperBoxBuilder) return;
  window.__vesperBoxBuilder = true;

  function bubble(count) {
    document.querySelectorAll('.cart-bubble').forEach(function (b) { b.classList.remove('visually-hidden'); });
    document.querySelectorAll('.cart-bubble__text-count').forEach(function (n) {
      n.textContent = count;
      n.classList.remove('hidden');
    });
  }
  function money(cents, cur) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur || 'USD' }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }
  function uid() { return Date.now().toString(36) + Math.random().toString(36).slice(2, 7); }
  function byId(list, id) {
    for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i];
    return null;
  }
  function firstAvail(choice) {
    var v = choice.variants;
    for (var i = 0; i < v.length; i++) if (v[i].available) return v[i].id;
    return v.length ? v[0].id : 0;
  }

  function init(root) {
    if (root.__bb) return;
    var dataEl = root.querySelector('[data-bb-data]');
    if (!dataEl) return;
    var D;
    try { D = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var T = root.dataset;
    var cur = T.currency;
    var maxQty = parseInt(T.maxQty, 10) || 10;
    var allowDup = T.allowDup === 'true';
    var slotEls = root.querySelectorAll('[data-bb-slot]');
    var tileEls = root.querySelectorAll('[data-bb-tile]');
    var el = {
      lines: root.querySelector('[data-bb-lines]'),
      total: root.querySelector('[data-bb-total]'),
      add: root.querySelector('[data-bb-add]'),
      msg: root.querySelector('[data-bb-msg]'),
      qty: root.querySelector('[data-bb-qtyinput]'),
      gift: root.querySelector('[data-bb-gift]'),
      giftCount: root.querySelector('[data-bb-giftcount]'),
      boxVar: root.querySelector('[data-bb-boxvariant]')
    };
    var st = { qty: 1, boxV: D.box.variant, sel: [], busy: false, msgKind: '' };
    root.__bb = st;

    /* ---- starting selection: the default if it is in stock, else the first one that is ---- */
    function taken(except) {
      var h = {};
      for (var k = 0; k < st.sel.length; k++) {
        if (k !== except && st.sel[k] && st.sel[k].c >= 0) h[D.slots[k].choices[st.sel[k].c].handle] = true;
      }
      return h;
    }
    D.slots.forEach(function (slot, i) {
      var idx = -1, used = allowDup ? {} : taken(i);
      var d = slot.choices[slot.def];
      if (d && d.available && !used[d.handle]) idx = slot.def;
      else {
        for (var j = 0; j < slot.choices.length; j++) {
          if (slot.choices[j].available && !used[slot.choices[j].handle]) { idx = j; break; }
        }
      }
      st.sel[i] = { c: idx, v: idx >= 0 ? firstAvail(slot.choices[idx]) : 0 };
    });

    function pick(i) {
      var c = D.slots[i].choices[st.sel[i].c];
      if (!c) return null;
      return { c: c, v: byId(c.variants, st.sel[i].v) || c.variants[0] };
    }
    function boxVariant() { return byId(D.box.variants, st.boxV); }
    function boxIncluded() {
      var bv = boxVariant();
      if (!bv) return false;
      if (T.boxLine === 'always') return true;
      if (T.boxLine === 'auto') return bv.price > 0;
      return false;
    }
    function imgFor(p) { return p.c.fixed ? p.c.img : (p.v.img || p.c.img); }

    function setTile(tile, src, name) {
      var img = tile.querySelector('[data-bb-tileimg]');
      var empty = tile.querySelector('[data-bb-tileempty]');
      var nameEl = tile.querySelector('[data-bb-tilename]');
      if (nameEl) nameEl.textContent = name || '';
      if (!src) {
        img.hidden = true;
        empty.hidden = false;
        return;
      }
      empty.hidden = true;
      img.hidden = false;
      img.alt = name || '';
      if (img.getAttribute('src') === src) return;
      var done = function () { img.classList.remove('is-swapping'); };
      img.classList.add('is-swapping');
      img.onload = done;
      img.onerror = done;
      img.src = src;
      setTimeout(done, 700);
    }

    function setOpen(i, open) {
      slotEls.forEach(function (s, k) {
        var body = s.querySelector('.bb-slot-body');
        var btn = s.querySelector('[data-bb-toggle]');
        if (!body || !btn) return;
        var on = k === i && open;
        body.hidden = !on;
        btn.setAttribute('aria-expanded', on ? 'true' : 'false');
        btn.textContent = on ? T.tDone : T.tChange;
        s.classList.toggle('is-open', on);
      });
    }

    function render() {
      var total = 0, missing = [], lines = [];
      var bv = boxVariant();
      if (boxIncluded()) {
        total += bv.price;
        lines.push([T.tBox + (bv.title && bv.title !== 'Default Title' ? ' (' + bv.title + ')' : ''), bv.price]);
        if (!bv.available) missing.push(T.tBox);
      }
      D.slots.forEach(function (slot, i) {
        var p = pick(i), slotEl = slotEls[i], used = allowDup ? {} : taken(i);
        setTile(tileEls[i], p ? imgFor(p) : '', p ? p.c.title : '');
        slotEl.querySelector('[data-bb-current]').textContent = p ? p.c.title + ' \u00B7 ' + money(p.v.price, cur) : T.tSkipped;
        if (p) {
          total += p.v.price;
          var vt = p.c.variants.length > 1 ? ' (' + p.v.title + ')' : '';
          lines.push([p.c.title + vt, p.v.price]);
        } else if (!slot.optional) {
          missing.push(slot.label);
        }

        slotEl.querySelectorAll('.bb-choice-input').forEach(function (inp) {
          var val = parseInt(inp.value, 10);
          var on = val === st.sel[i].c;
          inp.checked = on;
          var card = inp.closest('.bb-choice');
          if (!card) return;
          var ch = slot.choices[val];
          var isTaken = !allowDup && !!used[ch.handle] && !on;
          card.classList.toggle('is-selected', on);
          card.classList.toggle('is-taken', isTaken);
          inp.disabled = !ch.available || isTaken;
          var flag = card.querySelector('[data-bb-flag]');
          if (flag) flag.textContent = !ch.available ? T.tSold : (isTaken ? T.tTaken : '');
        });

        var wrap = slotEl.querySelector('[data-bb-variantwrap]');
        var sel = slotEl.querySelector('[data-bb-variant]');
        if (p && p.c.variants.length > 1) {
          wrap.hidden = false;
          if (sel.__choice !== st.sel[i].c) {
            sel.__choice = st.sel[i].c;
            sel.innerHTML = '';
            p.c.variants.forEach(function (v) {
              var o = document.createElement('option');
              o.value = String(v.id);
              o.textContent = v.title + ' \u2013 ' + money(v.price, cur) + (v.available ? '' : ' (' + T.tSold + ')');
              o.disabled = !v.available;
              sel.appendChild(o);
            });
            slotEl.querySelector('[data-bb-optname]').textContent = p.c.opt;
          }
          sel.value = String(st.sel[i].v);
        } else {
          wrap.hidden = true;
        }
      });

      el.lines.innerHTML = '';
      lines.forEach(function (l) {
        var li = document.createElement('li');
        var a = document.createElement('span'), b = document.createElement('span');
        a.textContent = l[0];
        b.textContent = money(l[1], cur);
        li.appendChild(a);
        li.appendChild(b);
        el.lines.appendChild(li);
      });
      if (st.qty > 1) {
        var q = document.createElement('li');
        var qa = document.createElement('span'), qb = document.createElement('span');
        qa.textContent = '\u00D7 ' + st.qty;
        qb.textContent = '';
        q.appendChild(qa);
        q.appendChild(qb);
        el.lines.appendChild(q);
      }
      total = total * st.qty;
      el.total.textContent = money(total, cur);
      el.qty.value = st.qty;
      el.add.disabled = missing.length > 0 || st.busy;
      if (!st.busy && st.msgKind !== 'done') el.add.textContent = T.tAdd + ' \u2014 ' + money(total, cur);

      if (missing.length) {
        el.msg.textContent = T.tMissing + ' ' + missing.join(', ');
        st.msgKind = 'missing';
      } else if (st.msgKind === 'missing') {
        el.msg.textContent = '';
        st.msgKind = '';
      }
    }

    /* ---- adding to the cart: exactly what the preview shows ---- */
    function tryTheme(cart, resp) {
      try {
        return import('@theme/events').then(function (m) {
          if (m && typeof m.CartAddEvent === 'function') {
            document.dispatchEvent(new m.CartAddEvent({}, 'vesper-box-builder', {
              source: 'vesper-box-builder', itemCount: cart.item_count, sections: (resp && resp.sections) || {}
            }));
            return true;
          }
          return false;
        }).catch(function () { return false; });
      } catch (err) {
        return Promise.resolve(false);
      }
    }
    function showAdded() {
      el.msg.textContent = '';
      el.msg.appendChild(document.createTextNode(T.tAdded + ' '));
      var a = document.createElement('a');
      a.href = T.cartUrl;
      a.textContent = T.tView;
      el.msg.appendChild(a);
    }
    function add() {
      if (st.busy || el.add.disabled) return;
      var id = uid();
      var gift = el.gift ? el.gift.value.trim() : '';
      var items = [];
      function props() {
        var p = {};
        p[T.propLabel || 'Gift box'] = T.boxTitle;
        p._box_id = id;
        if (!items.length && gift) p['Gift message'] = gift;
        return p;
      }
      if (boxIncluded()) items.push({ id: st.boxV, quantity: st.qty, properties: props() });
      D.slots.forEach(function (slot, i) {
        var p = pick(i);
        if (p) items.push({ id: p.v.id, quantity: st.qty, properties: props() });
      });
      if (!items.length) return;

      st.busy = true;
      st.msgKind = '';
      el.msg.textContent = '';
      el.add.disabled = true;
      el.add.setAttribute('aria-busy', 'true');

      fetch(T.addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          return r.json().then(function (j) {
            if (!r.ok) throw new Error(j.description || j.message || 'error');
            return j;
          });
        })
        .then(function (resp) {
          return fetch(T.cartJs, { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) { return { cart: cart, resp: resp }; });
        })
        .then(function (x) {
          bubble(x.cart.item_count);
          document.dispatchEvent(new CustomEvent('vesper:cart-add', { detail: { cart: x.cart } }));
          st.msgKind = 'done';
          el.add.textContent = T.tAdded;
          if (T.afterAdd === 'drawer') {
            return tryTheme(x.cart, x.resp).then(function (ok) {
              if (ok) showAdded(); else window.location.href = T.cartUrl;
            });
          }
          window.location.href = T.cartUrl;
        })
        .catch(function (err) {
          st.msgKind = 'error';
          el.msg.textContent = (err && err.message && err.message !== 'error') ? err.message : T.tError;
        })
        .then(function () {
          st.busy = false;
          el.add.removeAttribute('aria-busy');
          if (st.msgKind === 'done') {
            setTimeout(function () { st.msgKind = ''; render(); }, 2500);
          }
          render();
        });
    }

    /* ---- events ---- */
    root.addEventListener('click', function (e) {
      var t = e.target;
      var tab = t.closest('[data-bb-tab]');
      if (tab) {
        var name = tab.dataset.bbTab;
        root.querySelectorAll('[data-bb-tab]').forEach(function (b) {
          var on = b === tab;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        root.querySelectorAll('[data-bb-pane]').forEach(function (p) { p.hidden = p.dataset.bbPane !== name; });
        return;
      }
      var tile = t.closest('[data-bb-tile]');
      if (tile) {
        var i = parseInt(tile.dataset.bbTile, 10);
        var slotEl = slotEls[i];
        if (!slotEl) return;
        if (slotEl.querySelector('[data-bb-toggle]')) setOpen(i, true);
        if (slotEl.scrollIntoView) slotEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      var tg = t.closest('[data-bb-toggle]');
      if (tg) {
        var k = parseInt(tg.closest('[data-bb-slot]').dataset.bbSlot, 10);
        var body = slotEls[k].querySelector('.bb-slot-body');
        setOpen(k, body.hidden);
        return;
      }
      var q = t.closest('[data-bb-qty]');
      if (q) {
        st.qty = Math.max(1, Math.min(maxQty, st.qty + parseInt(q.dataset.bbQty, 10)));
        render();
        return;
      }
      if (t.closest('[data-bb-add]')) add();
    });

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.classList && t.classList.contains('bb-choice-input')) {
        var i = parseInt(t.closest('[data-bb-slot]').dataset.bbSlot, 10);
        var val = parseInt(t.value, 10);
        var choice = D.slots[i].choices[val];
        st.sel[i] = { c: val, v: choice ? firstAvail(choice) : 0 };
        setOpen(i, false);
        var btn = slotEls[i].querySelector('[data-bb-toggle]');
        if (btn) btn.focus();
        render();
        return;
      }
      if (t.matches && t.matches('[data-bb-variant]')) {
        var si = parseInt(t.closest('[data-bb-slot]').dataset.bbSlot, 10);
        st.sel[si].v = parseInt(t.value, 10);
        render();
        return;
      }
      if (t === el.boxVar) {
        st.boxV = parseInt(t.value, 10);
        render();
        return;
      }
      if (t === el.qty) {
        var n = parseInt(t.value, 10);
        st.qty = isNaN(n) ? 1 : Math.max(1, Math.min(maxQty, n));
        render();
      }
    });
    if (el.gift && el.giftCount) {
      var count = function () { el.giftCount.textContent = el.gift.value.length + '/' + el.gift.maxLength; };
      el.gift.addEventListener('input', count);
      count();
    }

    render();
  }

  function boot() { document.querySelectorAll('[data-bb]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector ? e.target.querySelector('[data-bb]') : null;
    if (r) init(r);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vesper-collection"]) return;
  try {
    
(function () {
  if (window.__vesperCollection) return;
  window.__vesperCollection = true;

  var root = function () {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var money = function (cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  };
  var sized = function (url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  };
  var norm = function (u) {
    return String(u || '').replace(/^https?:/, '').split('?')[0];
  };

  /* ---------------- Filters ---------------- */
  var timer;

  function disableEmpty(form) {
    form.querySelectorAll('input[type="number"], input[type="text"]').forEach(function (i) {
      if (!i.value) i.disabled = true;
    });
  }
  function submitForm(form) {
    if (form.requestSubmit) {
      form.requestSubmit();
    } else {
      disableEmpty(form);
      form.submit();
    }
  }
  function isManual(vc) {
    return vc.classList.contains('vc--drawer') ||
      vc.classList.contains('vc--manual') ||
      window.matchMedia('(max-width: 989.98px)').matches;
  }
  function closeFilters(vc) {
    if (!vc) return;
    vc.classList.remove('is-filters-open');
    document.documentElement.style.overflow = '';
    var opener = vc.querySelector('[data-vc-open-filters]');
    if (opener) {
      opener.setAttribute('aria-expanded', 'false');
      opener.focus();
    }
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.matches && f.matches('[data-vc-form]')) disableEmpty(f);
  });

  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-vc-form] input:disabled').forEach(function (i) {
      if (i.type === 'number' || i.type === 'text') i.disabled = false;
    });
  });

  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el.closest) return;
    var form = el.closest('[data-vc-form]');
    if (!form) return;
    var vc = form.closest('.vc');
    if (el.matches('[data-vc-sort]')) {
      submitForm(form);
      return;
    }
    if (!el.matches('[data-vc-auto]')) return;
    if (isManual(vc)) return;
    clearTimeout(timer);
    timer = setTimeout(function () { submitForm(form); }, 350);
  });

  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target && e.target.matches && e.target.matches('[data-vc-pop]')) {
      e.preventDefault();
      e.target.click();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.vc.is-filters-open').forEach(closeFilters);
    }
  });

  /* ---------------- Card swatches ---------------- */
  function primaryImg(card) { return card.querySelector('.vc-img--primary'); }

  function showImage(card, url) {
    var img = primaryImg(card);
    if (!img || !url) return;
    if (!img.dataset.vcSrc) {
      img.dataset.vcSrc = img.getAttribute('src') || '';
      img.dataset.vcSrcset = img.getAttribute('srcset') || '';
    }
    img.removeAttribute('srcset');
    img.src = url;
    card.classList.add('is-swapped');
  }
  function restoreImage(card) {
    var img = primaryImg(card);
    if (!img || !img.dataset.vcSrc) return;
    if (img.dataset.vcSrcset) img.setAttribute('srcset', img.dataset.vcSrcset);
    img.src = img.dataset.vcSrc;
    card.classList.remove('is-swapped');
  }
  function lockSwatch(sw) {
    var card = sw.closest('.vc-card');
    if (!card || !sw.dataset.image) return;
    card.querySelectorAll('.vc-sw').forEach(function (b) {
      b.classList.remove('is-active');
      b.setAttribute('aria-pressed', 'false');
    });
    sw.classList.add('is-active');
    sw.setAttribute('aria-pressed', 'true');
    card.dataset.vcLocked = sw.dataset.image;
    showImage(card, sw.dataset.image);
    if (sw.dataset.variant) {
      card.querySelectorAll('a.vc-media-link, a.vc-title').forEach(function (a) {
        a.href = a.href.split('?')[0] + '?variant=' + sw.dataset.variant;
      });
    }
  }

  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest && e.target.closest('[data-vc-swatch]');
    if (sw && sw.dataset.image) showImage(sw.closest('.vc-card'), sw.dataset.image);
  });
  document.addEventListener('mouseout', function (e) {
    var sw = e.target.closest && e.target.closest('[data-vc-swatch]');
    if (!sw) return;
    var card = sw.closest('.vc-card');
    if (card.dataset.vcLocked) showImage(card, card.dataset.vcLocked);
    else restoreImage(card);
  });

  /* ---------------- Quick view ---------------- */
  function bubble(count) {
    document.querySelectorAll('.cart-bubble').forEach(function (b) { b.classList.remove('visually-hidden'); });
    document.querySelectorAll('.cart-bubble__text-count').forEach(function (n) {
      n.textContent = count;
      n.classList.remove('hidden');
    });
  }

  function openQuickView(btn) {
    var vc = btn.closest('.vc');
    var dlg = vc.querySelector('.vc-qv');
    var card = btn.closest('.vc-card');
    var titleLink = card.querySelector('a.vc-title');
    if (!dlg || typeof dlg.showModal !== 'function') {
      if (titleLink) window.location.href = titleLink.href;
      return;
    }
    var swatches = {};
    try { swatches = JSON.parse(card.dataset.swatches || '{}'); } catch (err) {}
    var content = dlg.querySelector('.vc-qv-content');
    content.innerHTML = '<p class="vc-qv-loading">&hellip;</p>';
    dlg.__vc = null;
    if (!dlg.open) dlg.showModal();

    fetch(root() + 'products/' + encodeURIComponent(card.dataset.handle) + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('load'); return r.json(); })
      .then(function (p) { renderQV(vc, dlg, p, swatches); })
      .catch(function () {
        content.innerHTML = '<p class="vc-qv-error"><a href="' + esc(titleLink ? titleLink.href : '#') + '">' + esc(vc.dataset.qvDetails) + '</a></p>';
      });
  }

  function renderQV(vc, dlg, p, swatches) {
    var d = vc.dataset;
    var colorNames = (d.colorOptions || '').split('|').filter(Boolean);
    var variants = p.variants || [];
    var options = (p.options || []).map(function (o, i) {
      var name = typeof o === 'string' ? o : o.name;
      var vals = (typeof o === 'object' && o.values && o.values.length) ? o.values.slice() : [];
      if (!vals.length) {
        variants.forEach(function (v) {
          var x = v.options[i];
          if (vals.indexOf(x) < 0) vals.push(x);
        });
      }
      return { name: name, values: vals };
    });
    var single = options.length === 1 && options[0].values.length === 1 && options[0].values[0] === 'Default Title';
    var start = variants.filter(function (v) { return v.available; })[0] || variants[0];
    var imgs = (p.images && p.images.length) ? p.images : (p.featured_image ? [p.featured_image] : []);
    var url = p.url || (root() + 'products/' + p.handle);
    var st = { sel: start.options.slice(), qty: 1, cur: '' };

    var optHtml = '';
    if (!single) {
      options.forEach(function (o, i) {
        var isColor = colorNames.indexOf(String(o.name).toLowerCase()) > -1;
        optHtml += '<div class="vc-qv-opt"><div class="vc-qv-optname">' + esc(o.name) + ': <b data-vc-optlabel="' + i + '"></b></div><div class="vc-qv-vals">';
        o.values.forEach(function (v) {
          var sw = isColor && swatches[v];
          optHtml += '<button type="button" class="vc-qv-val' + (sw ? ' vc-qv-val--sw' : '') + '" data-opt="' + i + '" data-value="' + esc(v) + '"' +
            (sw ? ' style="--vc-sw:' + esc(sw) + '" aria-label="' + esc(v) + '" title="' + esc(v) + '"' : '') + '>' +
            (sw ? '' : esc(v)) + '</button>';
        });
        optHtml += '</div></div>';
      });
    }

    var thumbs = '';
    if (imgs.length > 1) {
      thumbs = '<div class="vc-qv-thumbs">';
      imgs.forEach(function (src, i) {
        thumbs += '<button type="button" class="vc-qv-thumb' + (i === 0 ? ' is-active' : '') + '" data-src="' + esc(src) + '"><img src="' + esc(sized(src, 160)) + '" alt="" loading="lazy"></button>';
      });
      thumbs += '</div>';
    }

    var desc = '';
    if (d.qvDesc === 'true' && p.description) {
      var text = new DOMParser().parseFromString(p.description, 'text/html').body.textContent.replace(/\s+/g, ' ').trim();
      if (text.length > 260) text = text.slice(0, 257).replace(/\s+\S*$/, '') + '\u2026';
      if (text) desc = '<p class="vc-qv-desc">' + esc(text) + '</p>';
    }

    dlg.querySelector('.vc-qv-content').innerHTML =
      '<div class="vc-qv-inner">' +
        '<div class="vc-qv-gallery">' +
          '<div class="vc-qv-main"><img class="vc-qv-img" alt="' + esc(p.title) + '" src="' + esc(sized(imgs[0], 1000)) + '"></div>' +
          thumbs +
        '</div>' +
        '<div class="vc-qv-info">' +
          '<h2 class="vc-qv-title">' + esc(p.title) + '</h2>' +
          '<div class="vc-qv-price"></div>' +
          optHtml +
          '<div class="vc-qv-qty"><button type="button" data-vc-qty="-1" aria-label="-">&minus;</button><span></span><button type="button" data-vc-qty="1" aria-label="+">+</button></div>' +
          '<button type="button" class="vc-qv-atc"></button>' +
          '<p class="vc-qv-msg" role="status" aria-live="polite"></p>' +
          desc +
          '<a class="vc-qv-more" href="' + esc(url) + '">' + esc(d.qvDetails) + '</a>' +
        '</div>' +
      '</div>';

    var el = {
      img: dlg.querySelector('.vc-qv-img'),
      price: dlg.querySelector('.vc-qv-price'),
      atc: dlg.querySelector('.vc-qv-atc'),
      msg: dlg.querySelector('.vc-qv-msg'),
      qty: dlg.querySelector('.vc-qv-qty span')
    };

    st.find = function () {
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === st.sel[i]; });
      })[0];
    };
    st.setImage = function (src) {
      if (norm(src) === st.cur) return;
      st.cur = norm(src);
      el.img.src = sized(src, 1000);
      dlg.querySelectorAll('.vc-qv-thumb').forEach(function (b) {
        b.classList.toggle('is-active', norm(b.dataset.src) === st.cur);
      });
    };
    st.sync = function () {
      var v = st.find();
      dlg.querySelectorAll('.vc-qv-val').forEach(function (b) {
        var i = +b.dataset.opt;
        var on = st.sel[i] === b.dataset.value;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var possible = variants.some(function (x) {
          return x.available && x.options.every(function (o, j) {
            return j === i ? o === b.dataset.value : o === st.sel[j];
          });
        });
        b.classList.toggle('is-unavailable', !possible);
      });
      dlg.querySelectorAll('[data-vc-optlabel]').forEach(function (n) {
        n.textContent = st.sel[+n.dataset.vcOptlabel];
      });
      if (v) {
        el.price.innerHTML = (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '') + '<span>' + money(v.price) + '</span>';
        if (v.featured_image && v.featured_image.src) st.setImage(v.featured_image.src);
        el.atc.disabled = !v.available;
        el.atc.textContent = v.available ? d.qvAtc : d.qvSold;
      } else {
        el.price.innerHTML = '';
        el.atc.disabled = true;
        el.atc.textContent = d.qvSold;
      }
      el.qty.textContent = st.qty;
    };
    st.add = function () {
      var v = st.find();
      if (!v || !v.available) return;
      el.atc.disabled = true;
      el.atc.setAttribute('aria-busy', 'true');
      el.msg.textContent = '';
      fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: st.qty }] })
      })
        .then(function (r) {
          return r.json().then(function (j) {
            if (!r.ok) throw new Error(j.description || j.message || 'error');
            return j;
          });
        })
        .then(function () {
          return fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          bubble(cart.item_count);
          document.dispatchEvent(new CustomEvent('vesper:cart-add', { detail: { cart: cart } }));
          if (d.afterAdd === 'cart_page') {
            window.location.href = root() + 'cart';
            return;
          }
          el.msg.innerHTML = esc(d.qvAdded) + ' <a href="' + root() + 'cart">' + esc(d.qvCart) + '</a>';
        })
        .catch(function (err) {
          el.msg.textContent = (err && err.message && err.message !== 'error') ? err.message : 'Could not add to cart.';
        })
        .then(function () {
          el.atc.removeAttribute('aria-busy');
          st.sync();
        });
    };

    dlg.__vc = st;
    st.sync();
  }

  function handleQV(dlg, t) {
    if (t === dlg || t.closest('[data-vc-qv-close]')) {
      dlg.close();
      return;
    }
    var st = dlg.__vc;
    if (!st) return;
    var val = t.closest('.vc-qv-val');
    if (val) {
      st.sel[+val.dataset.opt] = val.dataset.value;
      st.sync();
      return;
    }
    var th = t.closest('.vc-qv-thumb');
    if (th) {
      st.setImage(th.dataset.src);
      return;
    }
    var q = t.closest('[data-vc-qty]');
    if (q) {
      st.qty = Math.max(1, st.qty + (+q.dataset.vcQty));
      st.sync();
      return;
    }
    if (t.closest('.vc-qv-atc')) st.add();
  }

  /* ---------------- One delegated click handler ---------------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;

    var popOpen = t.closest('[data-vc-pop]');
    if (popOpen) {
      var popLi = popOpen.closest('li');
      var popDlg = popLi && popLi.querySelector('dialog.vc-pop');
      if (popDlg && typeof popDlg.showModal === 'function' && !popDlg.open) popDlg.showModal();
      return;
    }
    if (t.closest('[data-vc-pop-close]')) { t.closest('dialog').close(); return; }
    if (t.classList && t.classList.contains('vc-pop')) { t.close(); return; }

    var dlg = t.closest('.vc-qv') || (t.classList && t.classList.contains('vc-qv') ? t : null);
    if (dlg) { handleQV(dlg, t); return; }

    var open = t.closest('[data-vc-open-filters]');
    if (open) {
      var vc = open.closest('.vc');
      vc.classList.add('is-filters-open');
      open.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      setTimeout(function () {
        var c = vc.querySelector('.vc-filters [data-vc-close-filters]');
        if (c) c.focus();
      }, 60);
      return;
    }

    var close = t.closest('[data-vc-close-filters]');
    if (close) { closeFilters(close.closest('.vc')); return; }

    var more = t.closest('[data-vc-more]');
    if (more) {
      var fbody = more.closest('.vc-fbody');
      var expanded = fbody.classList.toggle('is-expanded');
      more.textContent = expanded ? more.dataset.less : more.dataset.more;
      return;
    }

    var sw = t.closest('[data-vc-swatch]');
    if (sw) { lockSwatch(sw); return; }

    var qv = t.closest('[data-vc-qv]');
    if (qv) { openQuickView(qv); }
  });

  /* ---------------- Built-in filter engine (no Search & Discovery) ---------------- */
  var BI_SIZES = ['xxs', '2xs', 'xs', 's', 'm', 'l', 'xl', 'xxl', '2xl', '3xl', '4xl', '5xl'];

  function biClean(s) {
    return String(s == null ? '' : s)
      .replace(/[\uFEFF\u200B\u200C\u200D\u2060]/g, '')
      .replace(/\u00A0/g, ' ')
      .replace(/[\u2018\u2019]/g, "'")
      .replace(/[\u201C\u201D]/g, '"')
      .replace(/\s+/g, ' ')
      .trim();
  }
  function biKey(s) { return biClean(String(s == null ? '' : s).split(' [')[0]).toLowerCase(); }
  function biIsCode(s) { return /^(#|rgb|hsl|url\()/i.test(String(s || '')); }
  function biOn(obj) { return Object.keys(obj).filter(function (k) { return obj[k]; }); }
  function biList(text) {
    var out = [];
    String(text || '').split(/\r?\n/).forEach(function (line) {
      var i = line.indexOf(':');
      if (i > -1) {
        var nm = biClean(line.slice(0, i));
        if (nm) out.push({ name: nm, key: biKey(nm), extra: biClean(line.slice(i + 1)) });
      } else {
        line.split(',').forEach(function (part) {
          var n2 = biClean(part);
          if (n2) out.push({ name: n2, key: biKey(n2), extra: '' });
        });
      }
    });
    return out;
  }
  function biSort(a, b) {
    var ra = BI_SIZES.indexOf(a.key), rb = BI_SIZES.indexOf(b.key);
    if (ra > -1 && rb > -1) return ra - rb;
    if (ra > -1) return -1;
    if (rb > -1) return 1;
    return a.label.localeCompare(b.label, undefined, { numeric: true, sensitivity: 'base' });
  }

  function initBuiltIn(vc) {
    if (vc.__biReady) return;
    var cfg = [];
    try { cfg = JSON.parse(vc.dataset.biConfig || '[]'); } catch (e) {}
    var grid = vc.querySelector('.vc-grid');
    var form = vc.querySelector('[data-vc-form]');
    if (!cfg.length || !grid || !form) return;
    vc.__biReady = true;

    var colorMap = {};
    try {
      JSON.parse(vc.dataset.biColors || '[]').forEach(function (p) {
        var k = biKey(p[0]);
        if (!(k in colorMap)) colorMap[k] = p[1];
      });
    } catch (e) {}
    var showCounts = vc.dataset.biCounts === 'true';
    var limit = parseInt(vc.dataset.biLimit || '0', 10) || 0;
    var cur = vc.dataset.biCurrency || '';
    var customFirst = vc.dataset.biPriority === 'custom';
    var groups = [];
    var price = { min: null, max: null };
    var activeBox = vc.querySelector('[data-bi-active]');
    var emptyBox = vc.querySelector('[data-bi-empty]');
    var countEl = vc.querySelector('.vc-count');
    var applyBtn = vc.querySelector('.vc-filters-foot .vc-btn--primary');
    var applyLabel = applyBtn ? applyBtn.textContent : '';
    var clearBtn = null;

    function cards() { return Array.prototype.slice.call(grid.querySelectorAll('li.vc-item[data-bi-price]')); }

    function readCard(li) {
      if (li.__bi) return li.__bi;
      var o = { price: parseInt(li.getAttribute('data-bi-price'), 10) || 0, avail: li.getAttribute('data-bi-avail') === '1', vals: {} };
      for (var n = 1; n <= 10; n++) {
        var raw = li.getAttribute('data-bi-' + n);
        if (!raw) continue;
        var set = {}, labels = {};
        raw.split('|').forEach(function (x) {
          if (!biClean(x)) return;
          var k = biKey(x);
          set[k] = true;
          if (!labels[k]) labels[k] = biClean(x);
        });
        o.vals[n] = { set: set, labels: labels };
      }
      li.__bi = o;
      return o;
    }

    function nativeColors() {
      var map = {};
      Array.prototype.forEach.call(grid.querySelectorAll('.vc-card[data-swatches]'), function (c) {
        var j;
        try { j = JSON.parse(c.getAttribute('data-swatches') || '{}'); } catch (e) { return; }
        Object.keys(j).forEach(function (name) {
          var k = biKey(name);
          if (!(k in map) && j[name] && j[name] !== '#d8d8d8') map[k] = j[name];
        });
      });
      return map;
    }

    function build() {
      var list = cards();
      list.forEach(readCard);
      var native = nativeColors();
      groups = cfg.map(function (c) {
        var g = { n: c.n, title: c.title || '', kind: c.kind, sel: {}, values: [], look: 'pill' };
        var parsed = biList(c.vals);
        var hay = (String(c.title) + ' ' + String(c.src)).toLowerCase();
        var hasCode = parsed.some(function (e) { return biIsCode(e.extra); });
        if (hasCode || /colou?r|pattern/.test(hay)) g.look = 'color';
        else if (/size/.test(hay)) g.look = 'box';
        if (c.kind === 'price') { g.look = 'price'; return g; }
        if (c.kind === 'avail') {
          g.look = 'pill';
          g.values = [{ key: 'in', label: 'In stock', extra: '' }, { key: 'out', label: 'Out of stock', extra: '' }];
          return g;
        }
        var seen = {}, order = [];
        list.forEach(function (li) {
          var v = li.__bi.vals[c.n];
          if (!v) return;
          Object.keys(v.set).forEach(function (k) {
            if (!(k in seen)) { seen[k] = v.labels[k]; order.push(k); }
          });
        });
        var done = {};
        if (parsed.length) {
          parsed.forEach(function (e) {
            if (done[e.key]) return;
            done[e.key] = true;
            var label = seen[e.key] || e.name;
            if (g.look !== 'color' && e.extra && !biIsCode(e.extra)) label = e.extra;
            g.values.push({ key: e.key, label: label, extra: e.extra });
          });
        } else {
          g.values = order.map(function (k) { return { key: k, label: seen[k], extra: '' }; }).sort(biSort);
        }
        if (g.look === 'color') {
          g.values.forEach(function (v) {
            var col = v.extra;
            if (/^url\(/i.test(col) && col.indexOf('cover') < 0) col += ' center / cover no-repeat';
            if (!col) {
              var a = customFirst ? colorMap[v.key] : native[v.key];
              var b = customFirst ? native[v.key] : colorMap[v.key];
              col = a || b || '#d8d8d8';
            }
            v.color = col;
          });
        }
        return g;
      });
    }

    function groupHtml(g) {
      var kindCls = g.look === 'color' || g.look === 'price' ? 'pill' : g.look;
      var h = '<details class="vc-fgroup vc-fgroup--' + kindCls + ' vc-bi-group" data-bi-g="' + g.n + '" open><summary>' + esc(g.title) + '</summary><div class="vc-fbody">';
      if (g.look === 'price') {
        h += '<div class="vc-price-range">' +
          '<label><span class="vc-cur">' + esc(cur) + '</span><input type="number" min="0" inputmode="decimal" data-bi-pmin placeholder="' + esc(vc.dataset.biFrom || 'From') + '"></label>' +
          '<label><span class="vc-cur">' + esc(cur) + '</span><input type="number" min="0" inputmode="decimal" data-bi-pmax placeholder="' + esc(vc.dataset.biTo || 'To') + '"></label></div>';
      } else {
        g.values.forEach(function (v, i) {
          var isColor = g.look === 'color';
          var cls = 'vc-fval' + (isColor ? ' vc-fval--swatch' : '') + (limit > 0 && !isColor && i >= limit ? ' vc-fval--extra' : '');
          h += '<label class="' + cls + '"' + (isColor ? ' title="' + esc(v.label) + '"' : '') + '>' +
            '<input class="vc-finput" type="checkbox" data-bi-n="' + g.n + '" data-bi-k="' + esc(v.key) + '">' +
            (isColor ? '<span class="vc-fsw" style="--vc-sw: ' + esc(v.color) + '"></span>' : '') +
            '<span class="vc-fval-label' + (isColor ? ' vc-vh' : '') + '">' + esc(v.label) + '</span>' +
            (showCounts && !isColor ? '<span class="vc-fcount"></span>' : '') + '</label>';
        });
        if (limit > 0 && g.look !== 'color' && g.values.length > limit) {
          h += '<button type="button" class="vc-fmore" data-vc-more data-more="' + esc(vc.dataset.biMore || 'Show more') + '" data-less="' + esc(vc.dataset.biLess || 'Show less') + '">' + esc(vc.dataset.biMore || 'Show more') + '</button>';
        }
      }
      return h + '</div></details>';
    }

    function mount() {
      groups.forEach(function (g) {
        var slot = vc.querySelector('.vc-bi-slot[data-bi-slot="' + g.n + '"]');
        if (!slot) return;
        slot.innerHTML = groupHtml(g);
        g.el = slot.firstChild;
      });
      var foot = vc.querySelector('.vc-filters-foot');
      if (foot && !clearBtn) {
        clearBtn = document.createElement('button');
        clearBtn.type = 'button';
        clearBtn.className = 'vc-btn vc-bi-clear';
        clearBtn.setAttribute('data-bi-clear', '');
        clearBtn.textContent = (vc.dataset.biClear || 'Clear all');
        foot.appendChild(clearBtn);
      }
    }

    function pass(card, skip) {
      for (var i = 0; i < groups.length; i++) {
        var g = groups[i];
        if (g === skip) continue;
        if (g.look === 'price') {
          if (price.min != null && card.price < price.min * 100) return false;
          if (price.max != null && card.price > price.max * 100) return false;
          continue;
        }
        var keys = biOn(g.sel);
        if (!keys.length) continue;
        var hit = false;
        if (g.kind === 'avail') {
          keys.forEach(function (k) { if ((k === 'in' && card.avail) || (k === 'out' && !card.avail)) hit = true; });
        } else {
          var v = card.vals[g.n];
          if (v) keys.forEach(function (k) { if (v.set[k]) hit = true; });
        }
        if (!hit) return false;
      }
      return true;
    }

    function anyActive() {
      return price.min != null || price.max != null || groups.some(function (g) { return biOn(g.sel).length > 0; });
    }

    function writeUrl() {
      var u = new URL(window.location.href);
      var drop = [];
      u.searchParams.forEach(function (val, key) { if (/^f\d+$/.test(key) || key === 'pmin' || key === 'pmax') drop.push(key); });
      drop.forEach(function (k) { u.searchParams.delete(k); });
      groups.forEach(function (g) {
        var keys = biOn(g.sel);
        if (keys.length) u.searchParams.set('f' + g.n, keys.join('~'));
      });
      if (price.min != null) u.searchParams.set('pmin', price.min);
      if (price.max != null) u.searchParams.set('pmax', price.max);
      try { window.history.replaceState(null, '', u.toString()); } catch (e) {}
    }

    function readUrl() {
      var u = new URL(window.location.href);
      groups.forEach(function (g) {
        var p = u.searchParams.get('f' + g.n);
        if (p) p.split('~').forEach(function (k) { if (k) g.sel[k] = true; });
      });
      var a = parseFloat(u.searchParams.get('pmin')), b = parseFloat(u.searchParams.get('pmax'));
      price.min = isNaN(a) ? null : a;
      price.max = isNaN(b) ? null : b;
    }

    function chips() {
      if (!activeBox) return;
      var h = '';
      groups.forEach(function (g) {
        if (g.look === 'price') return;
        g.values.forEach(function (v) {
          if (g.sel[v.key]) h += '<button type="button" class="vc-pill" data-bi-remove="' + g.n + '|' + esc(v.key) + '">' + esc(v.label) + ' <span aria-hidden="true">&times;</span></button>';
        });
      });
      if (price.min != null || price.max != null) {
        h += '<button type="button" class="vc-pill" data-bi-remove="price">' + esc(cur) + (price.min != null ? price.min : '0') + ' &ndash; ' + (price.max != null ? esc(cur) + price.max : '&infin;') + ' <span aria-hidden="true">&times;</span></button>';
      }
      if (h) h += '<button type="button" class="vc-clear" data-bi-clear>' + esc(vc.dataset.biClear || 'Clear all') + '</button>';
      activeBox.innerHTML = h;
      activeBox.hidden = !h;
    }

    function apply() {
      var list = cards();
      var shown = 0;
      list.forEach(function (li) {
        var ok = pass(li.__bi, null);
        li.hidden = !ok;
        if (ok) shown++;
      });
      var active = anyActive();
      Array.prototype.forEach.call(grid.querySelectorAll('li.vc-item--promo'), function (p) { p.hidden = active; });

      groups.forEach(function (g) {
        if (!g.el || g.look === 'price') return;
        var map = {}, total = 0;
        g.values.forEach(function (v) { v.count = 0; map[v.key] = v; });
        list.forEach(function (li) {
          var c = li.__bi;
          if (g.kind === 'avail') { (c.avail ? map.in : map.out).count += pass(c, g) ? 1 : 0; return; }
          var vv = c.vals[g.n];
          if (!vv) return;
          var ok = pass(c, g);
          Object.keys(vv.set).forEach(function (k) {
            if (map[k]) { total++; if (ok) map[k].count++; }
          });
        });
        Array.prototype.forEach.call(g.el.querySelectorAll('input[data-bi-k]'), function (inp) {
          var v = map[inp.getAttribute('data-bi-k')];
          if (!v) return;
          var on = !!g.sel[v.key];
          inp.checked = on;
          var dead = v.count === 0 && !on;
          inp.disabled = dead;
          var lab = inp.parentNode;
          lab.classList.toggle('is-disabled', dead);
          var ce = lab.querySelector('.vc-fcount');
          if (ce) ce.textContent = '(' + v.count + ')';
        });
        g.el.hidden = g.kind !== 'avail' && total === 0 && !biOn(g.sel).length;
      });

      if (countEl) countEl.textContent = shown + ' ' + (shown === 1 ? 'product' : 'products');
      if (emptyBox) emptyBox.hidden = shown !== 0;
      if (applyBtn) applyBtn.textContent = applyLabel + ' (' + shown + ')';
      if (clearBtn) clearBtn.classList.toggle('is-on', active);
      chips();
      writeUrl();
    }

    function loadAll() {
      var pages = parseInt(vc.dataset.biPages || '1', 10) || 1;
      var here = parseInt(vc.dataset.biPage || '1', 10) || 1;
      var cap = Math.min(pages, 12);
      var jobs = [];
      for (var p = 1; p <= cap; p++) {
        if (p === here) continue;
        (function (page) {
          var u = new URL(window.location.href);
          u.searchParams.set('page', page);
          jobs.push(
            fetch(u.toString(), { credentials: 'same-origin' })
              .then(function (r) { return r.text(); })
              .then(function (html) {
                var doc = new DOMParser().parseFromString(html, 'text/html');
                return { page: page, items: Array.prototype.slice.call(doc.querySelectorAll('.vc-grid > li.vc-item[data-bi-price]')) };
              })
              .catch(function () { return { page: page, items: [] }; })
          );
        })(p);
      }
      return Promise.all(jobs).then(function (res) {
        res.sort(function (a, b) { return a.page - b.page; });
        var first = grid.querySelector('li.vc-item[data-bi-price]');
        res.forEach(function (r) {
          r.items.forEach(function (li) {
            var node = document.importNode(li, true);
            if (r.page < here) grid.insertBefore(node, first);
            else grid.appendChild(node);
          });
        });
        if (cap >= pages) {
          var nav = vc.querySelector('.vc-pagination');
          if (nav) nav.hidden = true;
        }
      });
    }

    vc.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches) return;
      if (t.matches('input[data-bi-k]')) {
        var g = groups.filter(function (x) { return String(x.n) === t.getAttribute('data-bi-n'); })[0];
        if (!g) return;
        g.sel[t.getAttribute('data-bi-k')] = t.checked;
        apply();
      } else if (t.matches('[data-bi-pmin],[data-bi-pmax]')) {
        var lo = vc.querySelector('[data-bi-pmin]'), hi = vc.querySelector('[data-bi-pmax]');
        var a = lo && lo.value !== '' ? parseFloat(lo.value) : null;
        var b = hi && hi.value !== '' ? parseFloat(hi.value) : null;
        price.min = a != null && !isNaN(a) ? a : null;
        price.max = b != null && !isNaN(b) ? b : null;
        apply();
      }
    });

    vc.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var rm = t.closest('[data-bi-remove]');
      if (rm) {
        var spec = rm.getAttribute('data-bi-remove');
        if (spec === 'price') { price.min = null; price.max = null; syncPrice(); }
        else {
          var parts = spec.split('|');
          groups.forEach(function (g) { if (String(g.n) === parts[0]) g.sel[parts[1]] = false; });
        }
        apply();
        return;
      }
      if (t.closest('[data-bi-clear]')) {
        groups.forEach(function (g) { g.sel = {}; });
        price.min = null; price.max = null;
        syncPrice();
        apply();
      }
    });

    function syncPrice() {
      var lo = vc.querySelector('[data-bi-pmin]'), hi = vc.querySelector('[data-bi-pmax]');
      if (lo) lo.value = price.min != null ? price.min : '';
      if (hi) hi.value = price.max != null ? price.max : '';
    }

    form.addEventListener('submit', function (e) {
      if (e.submitter && e.submitter.classList && e.submitter.classList.contains('vc-btn--primary')) {
        e.preventDefault();
        closeFilters(vc);
        return;
      }
      Array.prototype.forEach.call(form.querySelectorAll('input[data-bi-hidden]'), function (i) { i.parentNode.removeChild(i); });
      var u = new URL(window.location.href);
      u.searchParams.forEach(function (val, key) {
        if (/^f\d+$/.test(key) || key === 'pmin' || key === 'pmax') {
          var inp = document.createElement('input');
          inp.type = 'hidden';
          inp.name = key;
          inp.value = val;
          inp.setAttribute('data-bi-hidden', '');
          form.appendChild(inp);
        }
      });
    });

    loadAll().catch(function () {}).then(function () {
      build();
      mount();
      readUrl();
      syncPrice();
      apply();
      vc.setAttribute('data-bi-ready', 'true');
    });
  }

  function bootBuiltIn() {
    Array.prototype.forEach.call(document.querySelectorAll('.vc[data-bi]'), initBuiltIn);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootBuiltIn);
  else bootBuiltIn();
  document.addEventListener('shopify:section:load', bootBuiltIn);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vesper-creator-program"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var QUESTIONS = [
    { id: 'platform', q: 'Where do you post most?', opts: [['tiktok', 'TikTok'], ['instagram', 'Instagram'], ['youtube', 'YouTube'], ['pinterest', 'Pinterest'], ['other', 'Somewhere else']] },
    { id: 'followers', q: 'About how many followers do you have there?', opts: [['u1k', 'Under 1,000'], ['1k-10k', '1,000 to 10,000'], ['10k-50k', '10,000 to 50,000'], ['50k-100k', '50,000 to 100,000'], ['100k-plus', 'More than 100,000']] },
    { id: 'niche', q: 'What do you mostly make content about?', opts: [['sleep-selfcare', 'Sleep and self-care'], ['beauty-hair', 'Beauty and hair'], ['fashion', 'Fashion and dresses'], ['weddings', 'Weddings and gifting'], ['lifestyle', 'Lifestyle and home']] },
    { id: 'frequency', q: 'How often do you post?', opts: [['daily', 'Most days'], ['few-week', 'A few times a week'], ['weekly', 'About once a week'], ['occasional', 'Now and then']] },
    { id: 'interest', q: 'What would you most like to feature first?', opts: [['mask', 'Silk sleep and self-care'], ['hair', 'Hair tools and silk hair care'], ['dress', 'Dresses and gowns'], ['gift', 'Gift boxes']] }
  ];
  var TRACKS = { mask: 'Sleep and self-care', hair: 'Hair and beauty', dress: 'Dress and occasion', gift: 'Gifting' };
  var KEY = 'vcp_answers';

  function store(val) {
    try { if (val === null) { sessionStorage.removeItem(KEY); } else { sessionStorage.setItem(KEY, JSON.stringify(val)); } } catch (e) { /* storage unavailable */ }
  }
  function load() {
    try { var v = sessionStorage.getItem(KEY); return v ? JSON.parse(v) : null; } catch (e) { return null; }
  }
  function slug(v) { return String(v || '').toLowerCase().replace(/^@/, '').replace(/[^a-z0-9._-]/g, '').slice(0, 60); }
  function parseBday(v) {
    var m = /^\s*(\d{1,2})\s*[\/.-]\s*(\d{1,2})\s*$/.exec(v || '');
    if (!m) { return ''; }
    var mo = parseInt(m[1], 10), d = parseInt(m[2], 10);
    if (mo < 1 || mo > 12 || d < 1 || d > 31) { return ''; }
    return (mo < 10 ? '0' : '') + mo + '-' + (d < 10 ? '0' : '') + d;
  }
  function buildTags(a, handle, bday, path, city, salon) {
    var t = ['creator-applicant', 'creator-level-1', 'creator-source-circle'];
    ['platform', 'followers', 'niche', 'frequency', 'interest'].forEach(function (k) { if (a[k]) { t.push('creator-' + k + '-' + a[k]); } });
    if (a.followers === '100k-plus') { t.push('creator-priority-review'); }
    var h = slug(handle);
    if (h) { t.push('creator-handle-' + h); }
    if (bday) { t.push('creator-birthday-' + bday); }
    t.push('creator-path-' + (path === 'oil' ? 'oil' : 'mask'));
    var c = String(city || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 40);
    if (c) { t.push('creator-city-' + c); }
    if (salon) { t.push('creator-salon-match'); }
    return t.join(',');
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) { n.className = cls; }
    if (text) { n.textContent = text; }
    return n;
  }

  function init(root) {
    if (!root || root.__vcpReady) { return; }
    root.__vcpReady = true;

    var videos = root.getAttribute('data-videos') || '3';
    var largeNote = root.getAttribute('data-large-note') || '';
    var mount = root.querySelector('[data-vcp-quiz]');
    var formWrap = root.querySelector('[data-vcp-formwrap]');
    var form = root.querySelector('.vcp-form');
    var posted = root.querySelector('[data-vcp-posted]');
    var hadErrors = root.querySelector('[data-vcp-errors]');
    var resultTitle = root.querySelector('[data-vcp-result-title]');
    var resultText = root.querySelector('[data-vcp-result-text]');
    var largeEl = root.querySelector('[data-vcp-large]');
    var retake = root.querySelector('[data-vcp-retake]');
    var start = root.querySelector('[data-vcp-start]');
    var card = formWrap ? formWrap.parentNode : null;
    if (!mount || !formWrap || !form) { return; }

    var answers = {};
    var step = 0;

    function showForm() {
      mount.hidden = true;
      formWrap.hidden = false;
      var track = TRACKS[answers.interest] || '';
      resultTitle.textContent = "You're in at Level 1: Guest";
      resultText.textContent = (track ? 'Your focus: ' + track + '. ' : '') +
        'Choose how you want to start, then tell us where to send your creator brief.';
      if (largeNote && answers.followers === '100k-plus') { largeEl.textContent = largeNote; largeEl.hidden = false; } else { largeEl.hidden = true; }
      resultTitle.focus();
    }

    function renderQuestion(focus) {
      var q = QUESTIONS[step];
      formWrap.hidden = true;
      mount.hidden = false;
      mount.textContent = '';

      var bar = el('div', 'vcp-progress');
      bar.setAttribute('role', 'progressbar');
      bar.setAttribute('aria-valuemin', '1');
      bar.setAttribute('aria-valuemax', String(QUESTIONS.length));
      bar.setAttribute('aria-valuenow', String(step + 1));
      bar.setAttribute('aria-label', 'Quiz progress');
      var fill = el('span');
      fill.style.width = (((step + 1) / QUESTIONS.length) * 100) + '%';
      bar.appendChild(fill);
      mount.appendChild(bar);

      mount.appendChild(el('p', 'vcp-step', 'Question ' + (step + 1) + ' of ' + QUESTIONS.length));
      var h = el('h2', 'vcp-q', q.q);
      h.setAttribute('tabindex', '-1');
      h.id = 'vcp-q-' + step;
      mount.appendChild(h);

      var group = el('div', 'vcp-opts');
      group.setAttribute('role', 'group');
      group.setAttribute('aria-labelledby', h.id);
      q.opts.forEach(function (o) {
        var b = el('button', 'vcp-opt', o[1]);
        b.type = 'button';
        b.setAttribute('aria-pressed', answers[q.id] === o[0] ? 'true' : 'false');
        b.addEventListener('click', function () {
          answers[q.id] = o[0];
          Array.prototype.forEach.call(group.children, function (c) { c.setAttribute('aria-pressed', c === b ? 'true' : 'false'); });
          setTimeout(function () {
            if (step < QUESTIONS.length - 1) { step += 1; renderQuestion(true); } else { store(answers); showForm(); }
          }, 160);
        });
        group.appendChild(b);
      });
      mount.appendChild(group);

      if (step > 0) {
        var back = el('button', 'vcp-link', 'Back');
        back.type = 'button';
        back.addEventListener('click', function () { step -= 1; renderQuestion(true); });
        mount.appendChild(back);
      }
      if (focus) { h.focus({ preventScroll: false }); }
    }

    function restart() { answers = {}; step = 0; store(null); renderQuestion(true); }

    if (start) {
      start.addEventListener('click', function () {
        setTimeout(function () { if (card) { card.focus(); } }, 350);
      });
    }
    if (retake) { retake.addEventListener('click', restart); }

    form.addEventListener('submit', function (e) {
      var msg = form.querySelector('[data-vcp-msg]');
      var trap = form.querySelector('[data-vcp-trap]');
      var handle = form.querySelector('[data-vcp-handle]');
      var bdayEl = form.querySelector('[data-vcp-bday]');
      var tags = form.querySelector('[data-vcp-tags]');
      function fail(text, field) {
        e.preventDefault();
        msg.textContent = text;
        msg.hidden = false;
        if (field) { field.focus(); }
      }
      msg.hidden = true;
      if (trap && trap.value) { e.preventDefault(); return; }
      if (!slug(handle.value)) { fail('Please enter your handle, for example @yourhandle.', handle); return; }
      var bday = '';
      if (bdayEl.value.replace(/\s/g, '')) {
        bday = parseBday(bdayEl.value);
        if (!bday) { fail('Please enter your birthday as MM/DD, for example 10/13.', bdayEl); return; }
      }
      var pathEl = form.querySelector('input[name="vcp_path"]:checked') || form.querySelector('input[type="hidden"][name="vcp_path"]');
      var cityEl = form.querySelector('[data-vcp-city]');
      var salonEl = form.querySelector('[data-vcp-salon]');
      tags.value = buildTags(answers, handle.value, bday, pathEl ? pathEl.value : 'mask', cityEl ? cityEl.value : '', salonEl ? salonEl.checked : false);
      store(answers);
      var btn = form.querySelector('[data-vcp-submit]');
      if (btn) { setTimeout(function () { btn.disabled = true; }, 0); }
    });

    if (posted) {
      root.classList.add('is-posted');
      mount.hidden = true;
      formWrap.hidden = false;
      store(null);
      var ph = posted.querySelector('h2');
      if (ph) { ph.focus(); }
      return;
    }
    if (hadErrors) {
      answers = load() || {};
      showForm();
      return;
    }
    renderQuestion(false);
  }

  function boot() { document.querySelectorAll('[data-vcp-root]').forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', function (e) { if (e.target) { e.target.querySelectorAll('[data-vcp-root]').forEach(init); } });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vesper-footer"] && !Shopify.designMode) return;
  try {
    
(function () {
  var mq = window.matchMedia('(min-width: 750px)');
  document.querySelectorAll('.vf').forEach(function (root) {
    var mode = root.getAttribute('data-vf-acc') || 'closed';
    var single = root.getAttribute('data-vf-single') === 'true';
    var items = root.querySelectorAll('details.vf-acc');
    var syncing = false;
    function sync() {
      syncing = true;
      items.forEach(function (d, i) {
        var open;
        if (mq.matches || mode === 'off' || mode === 'open') { open = true; }
        else if (mode === 'first') { open = i === 0; }
        else { open = false; }
        d.open = open;
      });
      window.setTimeout(function () { syncing = false; }, 0);
    }
    items.forEach(function (d) {
      var sum = d.querySelector('summary');
      if (sum) {
        sum.addEventListener('click', function (e) { if (mq.matches || mode === 'off') { e.preventDefault(); } });
      }
      d.addEventListener('toggle', function () {
        if (syncing || mq.matches || !single || !d.open) { return; }
        items.forEach(function (other) { if (other !== d && other.open) { other.open = false; } });
      });
    });
    sync();
    if (mq.addEventListener) { mq.addEventListener('change', sync); } else if (mq.addListener) { mq.addListener(sync); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vesper-gift-edit"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.vge').forEach(function (root) {
    var buttons = root.querySelectorAll('[data-vge-filter]');
    var cards = root.querySelectorAll('[data-vge-occasions]');
    var empty = root.querySelector('[data-vge-empty]');
    function apply(key) {
      var shown = 0;
      cards.forEach(function (c) {
        var occ = (c.getAttribute('data-vge-occasions') || '').split(' ');
        var show = key === 'all' || occ.indexOf(key) !== -1;
        c.hidden = !show;
        if (show) { shown += 1; }
      });
      if (empty) { empty.hidden = shown !== 0; }
      buttons.forEach(function (b) {
        var on = b.getAttribute('data-vge-filter') === key;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    buttons.forEach(function (b) {
      b.addEventListener('click', function () { apply(b.getAttribute('data-vge-filter')); });
    });
    try {
      var want = (new URLSearchParams(window.location.search).get('occasion') || '').toLowerCase();
      if (want && root.querySelector('[data-vge-filter="' + want.replace(/[^a-z0-9-]/g, '') + '"]')) { apply(want.replace(/[^a-z0-9-]/g, '')); }
    } catch (err) { /* ignore */ }
    var form = root.querySelector('[data-vge-code-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = form.querySelector('[data-vge-code]');
        var code = (input.value || '').replace(/[^A-Za-z0-9_-]/g, '');
        if (!code) { return; }
        var msg = root.querySelector('[data-vge-code-msg]');
        if (msg) { msg.hidden = false; }
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.location.pathname);
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vesper-host-in-a-box"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.hib-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var hp = form.querySelector('[name="hib_website"]');
      if (hp && hp.value) { e.preventDefault(); }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vesper-salon-partners"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.vsp-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var hp = form.querySelector('[name="vsp_website"]');
      if (hp && hp.value) { e.preventDefault(); }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vesper-shop-all"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.vsa').forEach(function (root) {
    var rows = root.querySelectorAll('[data-vsa-row]');
    var status = root.querySelector('[data-vsa-status]');
    var emptyMsg = root.querySelector('[data-vsa-empty]');
    var state = { delivery: 'all', stock: false };

    function visibleSlides(track) {
      return Array.prototype.filter.call(track.children, function (li) { return !li.hidden; });
    }

    function pages(track) {
      var w = track.clientWidth;
      if (!w) { return 1; }
      return Math.max(1, Math.ceil((track.scrollWidth - 4) / w));
    }

    function build(row) {
      var track = row.querySelector('[data-vsa-track]');
      var dots = row.querySelector('[data-vsa-dots]');
      var n = pages(track);
      dots.innerHTML = '';
      if (n < 2) { dots.hidden = true; } else { dots.hidden = false; }
      for (var i = 0; i < n; i++) {
        (function (idx) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'vsa-dot';
          d.setAttribute('role', 'tab');
          d.setAttribute('aria-label', 'Page ' + (idx + 1) + ' of ' + n);
          d.addEventListener('click', function () {
            track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
          });
          dots.appendChild(d);
        })(i);
      }
      sync(row);
    }

    function sync(row) {
      var track = row.querySelector('[data-vsa-track]');
      var dots = row.querySelectorAll('.vsa-dot');
      var prev = row.querySelector('[data-vsa-prev]');
      var next = row.querySelector('[data-vsa-next]');
      var w = track.clientWidth || 1;
      var maxLeft = track.scrollWidth - track.clientWidth;
      var idx = Math.round(track.scrollLeft / w);
      if (track.scrollLeft >= maxLeft - 2) { idx = dots.length - 1; }
      dots.forEach(function (d, i) {
        var on = i === idx;
        d.classList.toggle('is-active', on);
        d.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      if (prev) { prev.disabled = track.scrollLeft <= 2; }
      if (next) { next.disabled = track.scrollLeft >= maxLeft - 2; }
    }

    rows.forEach(function (row) {
      var track = row.querySelector('[data-vsa-track]');
      var prev = row.querySelector('[data-vsa-prev]');
      var next = row.querySelector('[data-vsa-next]');
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) { return; }
        ticking = true;
        window.requestAnimationFrame(function () { sync(row); ticking = false; });
      }, { passive: true });
      if (prev) { prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * 0.9, behavior: 'smooth' }); }); }
      if (next) { next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.9, behavior: 'smooth' }); }); }
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); track.scrollBy({ left: track.clientWidth * 0.5, behavior: 'smooth' }); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); track.scrollBy({ left: -track.clientWidth * 0.5, behavior: 'smooth' }); }
      });
      build(row);
    });

    function applyFilters() {
      var total = 0;
      var anyRow = false;
      rows.forEach(function (row) {
        var track = row.querySelector('[data-vsa-track]');
        var shown = 0;
        Array.prototype.forEach.call(track.children, function (li) {
          var okDelivery = state.delivery === 'all' || li.getAttribute('data-vsa-delivery') === state.delivery;
          var okStock = !state.stock || li.getAttribute('data-vsa-stock') === 'in';
          li.hidden = !(okDelivery && okStock);
          if (!li.hidden) { shown += 1; }
        });
        row.hidden = shown === 0;
        if (shown > 0) { anyRow = true; total += shown; }
        track.scrollLeft = 0;
        build(row);
      });
      if (status) { status.textContent = (state.delivery === 'all' && !state.stock) ? '' : total + ' products shown'; }
      if (emptyMsg) { emptyMsg.hidden = anyRow; }
    }

    root.querySelectorAll('[data-vsa-filter]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.delivery = b.getAttribute('data-vsa-filter');
        root.querySelectorAll('[data-vsa-filter]').forEach(function (x) {
          var on = x === b;
          x.classList.toggle('is-active', on);
          x.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        applyFilters();
      });
    });
    var stockBtn = root.querySelector('[data-vsa-instock]');
    if (stockBtn) {
      stockBtn.addEventListener('click', function () {
        state.stock = !state.stock;
        stockBtn.classList.toggle('is-active', state.stock);
        stockBtn.setAttribute('aria-pressed', state.stock ? 'true' : 'false');
        applyFilters();
      });
    }

    try {
      var want = (new URLSearchParams(window.location.search).get('delivery') || '').toLowerCase().replace(/[^a-z-]/g, '');
      var btn = want ? root.querySelector('[data-vsa-filter="' + want + '"]') : null;
      if (btn) { btn.click(); }
    } catch (err) { /* ignore */ }

    window.addEventListener('resize', function () { rows.forEach(build); });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
